<div
    class="file-drop-area border border-2 rounded p-4 text-center"
    [class.bg-light]="!fileOver"
    [class.text-white]="fileOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
>
    <div class="mb-3">
        <input type="file" id="fileUpload" multiple (change)="onFileSelected($event)" hidden />
        <label for="fileUpload" class="btn btn-primary">
            {{ 'FILE_UPLOAD_SELECT_HINT' | translate }}
        </label>
    </div>

    <div class="text-muted" *ngIf="files.length === 0 && thumbnails.length === 0 && displayNames.length === 0">
        {{ 'FILE_UPLOAD_SELECT_FILENAME_ALT' | translate }}
    </div>

    <div *ngIf="thumbnails.length > 0" class="row g-3 mt-3">
        <div class="col-6 col-md-4 col-lg-3" *ngFor="let thumb of thumbnails; let i = index">
            <div class="card h-100 shadow-sm">
                <img
                    [src]="thumb.thumbnail"
                    class="card-img-top img-fluid"
                    [alt]="thumb.file.name"
                    style="height: 150px; object-fit: cover"
                />
                <div class="card-body p-2 text-center">
                    <small class="d-block text-truncate">
                        {{ thumb.file.name }}
                    </small>
                    <button type="button" class="btn btn-sm btn-outline-danger mt-2" (click)="removeThumbnail(i)">
                        Remove
                    </button>
                </div>
            </div>
        </div>
    </div>

    <ul *ngIf="displayNames.length > 0" class="list-group list-group-flush mt-3">
        <li
            class="list-group-item d-flex justify-content-between align-items-center"
            *ngFor="let file of displayNames; let i = index"
        >
            <span class="text-truncate">{{ file.name }}</span>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeDisplayName(i)">Remove</button>
        </li>
    </ul>
</div>

<div *ngIf="showWarning" class="alert alert-warning mt-3">
    {{ 'FILE_UPLOAD_SIZE_EXCEEDED' | translate }}
</div>
